import { DarkButton } from '../../../components/dark-button';
import React from 'react';
import styles from '../page.module.css';

interface SkipModalProps {
	show: boolean;
	onClose: () => void;
	onUnderstand: () => void;
	mode?: 'skip' | 'complete';
}

const SkipModal: React.FC<SkipModalProps> = ({
	show,
	onClose,
	onUnderstand,
	mode = 'skip',
}) => {
	if (!show) return null;

	const isCompleteMode = mode === 'complete';
	const title = isCompleteMode ? 'All set' : 'Please note that!';
	const message = isCompleteMode
		? 'All guests are verified. Tap Understand to continue with pre-check-in.'
		: 'As per DET regulations, you must verify your accompanying guest at the hotel front desk or via the check-in kiosk to complete the check-in.';

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContent}>
				{/* IMAGE */}
				<img
					src={process.env.PUBLIC_URL + '/landingpage_skip.png'}
					alt="User"
					className={styles.skipIcon}
				/>

				{/* TITLE */}
				<h2 className={styles.noteHeading}>{title}</h2>

				{/* MESSAGES */}

				<p
					className="text-center"
					style={{ color: '#050505', fontWeight: 500, marginTop: '0.5rem' }}>
					<br />
					{message}
				</p>

				{/* VERTICAL BUTTONS */}
				<div className="d-flex flex-column gap-2 mt-1 theme-understand">
					<DarkButton
						text="Understand"
						filled
						hideArrow
						onClick={onUnderstand}
					/>
				</div>
				<div className="d-flex flex-column gap-2 mt-1 theme-close">
					<DarkButton text="Close" filled={false} hideArrow onClick={onClose} />
				</div>
			</div>
		</div>
	);
};
export default SkipModal;
